import { doDefaultFetch } from '@nhl/fetch-helpers';

const fetchCoachsChallenges = args => {
    const includeJson = [
        'challengingTeam.triCode',
        'opposingTeam.triCode',
        'affectedTeam.triCode',
        {
            game: [
                'id',
                'gameDate',
                'homeCoach',
                'awayCoach',
                'visitingScore',
                'homeScore',
                'gameType.id',
                'state.id',
                'homeTeam.triCode',
                'visitingTeam.triCode',
                {
                    gameFormat: [
                        'shootoutInUse',
                        'maxPeriod',
                        'regulationPeriods',
                    ],
                },
            ],
        },
    ];

    let url = '/site/api/coachsChallenge' +
        `?include=${JSON.stringify(includeJson)}` +
        '&cayenneExp=';

    if (args.challengingId !== null) {
        url += `challengingTeamId=${args.challengingId} and `;
    }

    if (args.opposingId !== null) {
        url += `opposingTeamId=${args.opposingId} and `;
    }

    if (args.initiator !== null) {
        url += `hockeyOpsChallenge=${args.initiator === 1 ? 'true' : 'false'} and `
    }

    if (args.gameType !== null) {
        url += `gameTypeId=${args.gameType} and `;
    }

    url += `gameDate >= "${args.fromDate}" and gameDate <= "${args.toDate}"`;

    if (args.start !== undefined) {
        url += `&start=${args.start}&limit=${args.limit}`;
    }

    if (args.sort !== undefined) {
        url += `&sort=[${args.sort.map(s => `{"property":"${s.id}","direction":"${s.desc ? 'DESC' : 'ASC'}"}`).join(',')}]`;
    }

    return doDefaultFetch(url, args);
};

export default {
    fetchCoachsChallenges
};
